import {getSafely} from 'shared/web';

import {FiltersType} from '../../../types/FiltersType';
import {UpdateFiltersFunction, useFilters} from '../../FiltersContext/FiltersContext';

type BooleanKeys<T> = Extract<
  {
    [K in keyof T]: T[K] extends boolean ? K : T[K] extends boolean | undefined ? K : never;
  }[keyof T],
  keyof T
>;

export type BooleanBasedFilterName = Exclude<
  BooleanKeys<FiltersType>,
  'isMarginAbsolute' | 'isPowerInKW'
>;

export const getBooleanBasedTags = (
  filterName: BooleanBasedFilterName,
  translation: string,
  filters: FiltersType,
  onUpdateFilters: UpdateFiltersFunction
) => {
  const filterValue = getSafely(filters, filterName);
  return filterValue
    ? [{label: translation, onDelete: () => onUpdateFilters(filterName, undefined)}]
    : [];
};

export const useGetBooleanBasedTags = () => {
  const {filters, onUpdateFilters} = useFilters();

  return (filterName: BooleanBasedFilterName, translation: string) =>
    getBooleanBasedTags(filterName, translation, filters, onUpdateFilters).map((tag) => ({
      ...tag,
      filterName,
    }));
};
